export const UPDATE_SWAP_TRANSACTION = 'UPDATE_SWAP_TRANSACTION'
